"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusContext = exports.FocusContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _ToolbarFocusDelegate = require("./ToolbarFocusDelegate");
const FocusContext = (0, _lodestarUtils.createContext)({
  activeElement: undefined,
  ensureFocusableElement: () => {},
  getFocusProps: () => ({
    onFocus: () => {},
    onKeyDown: () => {},
    onBlur: () => {}
  }),
  parentRef: () => {},
  overflowMenuPortalRef: () => {}
}, "FocusContext");
const useFocusContext = () => {
  return (0, _react.useContext)(FocusContext);
};
exports.useFocusContext = useFocusContext;
const FocusContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [activeElement, setActiveElement] = (0, _react.useState)(null);
  const {
    current: focusDelegate
  } = (0, _react.useRef)(new _ToolbarFocusDelegate.ToolbarFocusDelegate());
  const callbackRef = (0, _react.useCallback)(newElement => {
    if (newElement) {
      focusDelegate.setToolbarRootElement(newElement);
      setActiveElement(focusDelegate.getFirstEnabledElement() || focusDelegate.getFirstElement());
    }
  }, [focusDelegate]);
  const onFocus = (0, _react.useCallback)(evt => {
    setActiveElement(evt.target);
  }, []);
  const onKeyDown = (0, _react.useCallback)((evt, _ref2) => {
    let {
      circular = true,
      includeEndKey = false,
      includeHomeKey = false
    } = _ref2;
    if (activeElement) {
      const beforeElement = focusDelegate.getElementBefore(activeElement);
      const afterElement = focusDelegate.getElementAfter(activeElement);
      switch (evt.key) {
        case "ArrowRight":
          // this prevents scroll on arrow keys when overflow menu is open
          evt.preventDefault();
          if (afterElement) afterElement.focus();else if (circular) focusDelegate.getFirstElement()?.focus();
          break;
        case "ArrowLeft":
          // this prevents scroll on arrow keys when overflow menu is open
          evt.preventDefault();
          if (beforeElement) beforeElement.focus();else if (circular) focusDelegate.getLastElement()?.focus();
          break;
        case "Home":
          if (includeHomeKey) focusDelegate.getFirstElement()?.focus();
          break;
        case "End":
          if (includeEndKey) focusDelegate.getLastElement()?.focus();
          break;
      }
    }
  }, [activeElement, focusDelegate]);
  const portalCallbackRef = (0, _react.useCallback)(newElement => {
    if (newElement) {
      focusDelegate.setOverflowPortalRootElement(newElement);
    }
  }, [focusDelegate]);
  const getFocusProps = (0, _react.useCallback)(_ref3 => {
    let {
      onFocus: providedOnFocus,
      onKeyDown: providedOnKeyDown,
      onBlur: providedOnBlur,
      circular,
      includeEndKey,
      includeHomeKey
    } = _ref3;
    return {
      onFocus: evt => {
        onFocus(evt);
        providedOnFocus?.(evt);
      },
      onKeyDown: evt => {
        onKeyDown(evt, {
          circular,
          includeHomeKey,
          includeEndKey
        });
        providedOnKeyDown?.(evt);
      },
      onBlur: providedOnBlur || (() => {})
    };
  }, [onFocus, onKeyDown]);
  const ensureFocusableElement = (0, _react.useCallback)(() => {
    setActiveElement(focusDelegate.getFirstEnabledElement() || focusDelegate.getFirstElement());
  }, [focusDelegate]);
  const memoValue = (0, _react.useMemo)(() => ({
    activeElement,
    getFocusProps,
    toolbarRootRef: callbackRef,
    overflowMenuPortalRef: portalCallbackRef,
    parentRef: callbackRef,
    ensureFocusableElement
  }), [activeElement, callbackRef, ensureFocusableElement, getFocusProps, portalCallbackRef]);
  return /*#__PURE__*/_react.default.createElement(FocusContext.Provider, {
    value: memoValue
  }, children);
};
exports.FocusContextProvider = FocusContextProvider;
//# sourceMappingURL=FocusContext.js.map